import { Button, Card, CardContent, CardHeader, Grid, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Tooltip, Typography } from "@mui/material";
import MedicalInformationTwoToneIcon from '@mui/icons-material/MedicalInformationTwoTone';
import PriceChangeTwoToneIcon from '@mui/icons-material/PriceChangeTwoTone';
import Diversity3TwoToneIcon from '@mui/icons-material/Diversity3TwoTone';
import CheckCircleTwoToneIcon from '@mui/icons-material/CheckCircleTwoTone';
import jwt_decode from "jwt-decode";
import { useEffect, useState } from "react";
import dayjs from "dayjs";
import ShoppingCartTwoToneIcon from '@mui/icons-material/ShoppingCartTwoTone';
import SettingsSuggestTwoToneIcon from '@mui/icons-material/SettingsSuggestTwoTone';

dayjs.locale('es-mx')

export default function Menu() {

    const token = sessionStorage.getItem('token')
    const decoded = jwt_decode(token);
    const id = decoded.id;

    const [isComite, setIsComite] = useState(false)
    const [isMonitor, setIsMonitor] = useState(false)
    const [isTitular, setIsTitular] = useState(false)
    const [isAdminEmergencias, setIsAdminEmergencias] = useState(false)
    const [isAlumnoEmergencias, setIsAlumnoEmergencias] = useState(false)
    const [isAdminAdquisiciones, setIsAdminAdquisiciones] = useState(false)

    const obtenerReglasEmergencias = async () => {
        const controller = new AbortController();
        const signal = controller.signal;

        try {
            const resReglas = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_EMERGENCIAS_PORT}/reglas`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "x-access-token": token,
                    "perfil": sessionStorage.getItem('perfil')
                }, signal
            })
            const tokenReglasEmergencias = await resReglas.json()
            const reglas = jwt_decode(tokenReglasEmergencias)
            console.log(`reglas monitores ${JSON.stringify(reglas.reglas)}`)

            for (let j = 0; j < reglas.reglas.length; j++) {
                console.log(`reglas.reglas[${j}].action ${reglas.reglas[j].action} SUBJECT ${reglas.reglas[j].subject}`)
                if (reglas.reglas[j].action === 'administrador' && reglas.reglas[j].subject === 'emergencias') {
                    setIsAdminEmergencias(true)
                }
                if (reglas.reglas[j].action === 'alumno' && reglas.reglas[j].subject === 'emergencias') {
                    setIsAlumnoEmergencias(true)
                }
            }
        }
        catch (error) {
            if (error.name === 'AbortError') {
                console.error('Fetch aborted');
            } else {
                console.error('Fetch error:', error);
            }
        }
        return () => {
            controller.abort(); // Abort the request when the component unmounts
        };

    }

    const obtenerReglasAdquisiciones = async () => {
        const controller = new AbortController();
        const signal = controller.signal;

        try {
            const resReglas = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_ADQUISICIONES_PORT}/reglas`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "x-access-token": token,
                    "perfil": sessionStorage.getItem('perfil')
                }, signal
            })
            const tokenReglasAdquisiciones = await resReglas.json()
            const reglas = jwt_decode(tokenReglasAdquisiciones)
            console.log(`reglas adquisiciones ${JSON.stringify(reglas.reglas)}`)

            for (let j = 0; j < reglas.reglas.length; j++) {
                console.log(`reglas.reglas[${j}].action ${reglas.reglas[j].action} SUBJECT ${reglas.reglas[j].subject}`)
                if (reglas.reglas[j].action === 'administrador' && reglas.reglas[j].subject === 'csa') {
                    setIsAdminAdquisiciones(true)
                }
               
            }
        }
        catch (error) {
            if (error.name === 'AbortError') {
                console.error('Fetch aborted');
            } else {
                console.error('Fetch error:', error);
            }
        }
        return () => {
            controller.abort(); // Abort the request when the component unmounts
        };

    }

    const obtenerReglasMonitores = async () => {
        const controller = new AbortController();
        const signal = controller.signal;

        try {
            const resReglas = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_MONITORES_PORT}/reglas`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "x-access-token": token,
                    "perfil": sessionStorage.getItem('perfil')
                }, signal
            })
            const tokenReglasMonitores = await resReglas.json()
            const reglas = jwt_decode(tokenReglasMonitores)
            console.log(`reglas monitores ${JSON.stringify(reglas.reglas)}`)

            for (let j = 0; j < reglas.reglas.length; j++) {
                console.log(`reglas.reglas[${j}].action ${reglas.reglas[j].action} SUBJECT ${reglas.reglas[j].subject}`)
                if (reglas.reglas[j].action === 'comite' && reglas.reglas[j].subject === 'monitores') {
                    setIsComite(true)
                }
                if (reglas.reglas[j].action === 'titular' && reglas.reglas[j].subject === 'monitores') {
                    setIsTitular(true)
                }
                if (reglas.reglas[j].action === 'monitor' && reglas.reglas[j].subject === 'monitores') {
                    setIsMonitor(true)
                }
            }
        }
        catch (error) {
            if (error.name === 'AbortError') {
                console.error('Fetch aborted');
            } else {
                console.error('Fetch error:', error);
            }
        }
        return () => {
            controller.abort(); // Abort the request when the component unmounts
        };

        /*if (reglas[j].action === 'coordinacion' && reglas[j].subject === 'coordinacion') {
            //console.log('Entró a la de planPresupuestal')
            perfiles.push({id:perfil.id, descripcion:'Coordinación', idEntidad:perfil.idEntidad})
            rulesCoordinacion=reglas
        
        }*/

    }
    const obtenerReglas = (decoded) => {
        let reglas
        const perfilElegido = sessionStorage.getItem('perfilElegido')
        switch (perfilElegido) {
            case 'asistente':
                reglas = decoded.rulesAsistente
                break
            case 'investigador':
                reglas = decoded.rulesJefaturaArea
                break
            case 'coordinacion':
                reglas = decoded.rulesCoordinacion
                break
            case 'jefe':
                reglas = decoded.rulesJefatura
                break
            case 'administracion':
                reglas = decoded.rulesAdministracionProyecto
                break
            default:
                break
        }
        return reglas
    }
    let reglas = decoded.rules
    let isGestion = false

    if (!reglas)
        reglas = obtenerReglas(decoded)
    for (let i = 0; i < reglas.length; i++) {
        // console.log(`REGLA ${i} action ${reglas[i].action} subject ${reglas[i].subject}`)
        if (reglas[i].action === 'jefatura' && reglas[i].subject === 'area') {
            isGestion = true

            //navigate(`/seguimientoSolicitudes/rectoria/gestion/${usuario.id}`)

        }
        if (reglas[i].action === 'manage' && reglas[i].subject === 'planPresupuestal') {
            isGestion = true

            /*const resTitularPerfil = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/usuarios/idTitularPerfil/${sessionStorage.getItem('perfil')}`)
            const titular = await resTitularPerfil.json()
            sessionStorage.setItem('idTitularPerfil', titular.idEmpleado)
            await cargarPlan()
            setOpenAvisos(true)
            console.log(`sessionStorage ${JSON.stringify(sessionStorage)}`)
            Object.entries(sessionStorage).forEach(([key, value]) => {
                console.log(key)
                console.log(value)
              });
            navigate(`/`)*/
            //navigate('/false')

        }
        if (reglas[i].action === 'asistente' && reglas[i].subject === 'division') {
            isGestion = true

            //navigate(`/`)
            //navigate(`/seguimientoSolicitudes/division/${usuario.id}`)

        }
        if (reglas[i].action === 'administracion' && reglas[i].subject === 'proyecto') {
            isGestion = true

            //navigate(`/`)
            //navigate(`/seguimientoSolicitudes/division/${usuario.id}`)

        }
        if (reglas[i].action === 'jefatura' && reglas[i].subject === 'caja')
            isGestion = true

    }

    const guardarSesion = async (id, app) => {
        // AQUÍ SE OBTENDRÁ LA FECHA DE LA ÚLTIMA SESIÓN Y EN BASE A ELLA SE BUSCARÁN LAS ACTUALIZACIONES O REGISTROS DE SOLICITUDES
        // PARA INDICARLAS EN UN SNACKBAR
        const resUltimaSesion = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/usuarios/leerUltimaConexion/${id}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "x-access-token": sessionStorage.getItem('token'),
                "perfil": sessionStorage.getItem('perfil')
            },
        })
        if (resUltimaSesion.status === 500)
            sessionStorage.clear()
        const sesion = await resUltimaSesion.json()
        //console.log(`sesion ${JSON.stringify(sesion)}`)
        if (sesion && sesion.storage) {
            //const storage = sesion.storage
            const storage = typeof sesion.storage === 'string' ? JSON.parse(sesion.storage) : sesion.storage;

            /*console.log(`storage ${JSON.stringify(storage)}`);
            console.log(`storage ${storage}`)
            console.log(`actualConexionGestion ${storage.actualConexionGestion}`)
            console.log('Keys in storage:', Object.values(storage)); 
            console.log(`actualConexion${app}`+storage[`actualConexion${app}`])*/
            if (storage[`actualConexion${app}`]) {
                sessionStorage.setItem(`ultimaConexion${app}`, storage[`actualConexion${app}`])
                sessionStorage.setItem(`actualConexion${app}`, `${dayjs().format('YYYY-MM-DD HH:mm:ss.SSSZ')}`)
            }
            else {
                sessionStorage.setItem(`actualConexion${app}`, `${dayjs().format('YYYY-MM-DD HH:mm:ss.SSSZ')}`)
            }
        }
        //console.log(`sessionStorage ${JSON.stringify(sessionStorage)}`)  

        const res = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/usuarios/storage`, {
            method: "POST",
            body: JSON.stringify({ storage: sessionStorage, id: id }),
            headers: {
                "Content-Type": "application/json",
                "x-access-token": sessionStorage.getItem('token'),
                "perfil": sessionStorage.getItem('perfil')
            },
        })
        const data = await res.json()
        //console.log(`data ${JSON.stringify(data)}`)

        return data
    }

    const handleBuzon = async (id, hash) => {

        const data = await guardarSesion(id, 'Buzon')

        window.location.replace(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_FRONTEND_BUZON_PORT}/${data.id}#${hash}`)
    }

    const handleMonitores = async (id) => {

        const data = await guardarSesion(id, 'Monitores')

        window.location.replace(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_FRONTEND_MONITORES_PORT}/${data.id}`)
    }
    
    const handleEmergencias = async (id) => {

        const data = await guardarSesion(id, 'Emergencias')

        window.location.replace(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_FRONTEND_EMERGENCIAS_PORT}/${data.id}`)
    }

    const handleGestion = async (id) => {
        const data = await guardarSesion(id, 'Gestion')
        //console.log(`data ${JSON.stringify(data)}`)
        //return
        window.location.replace(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_FRONTEND_GESTION_PORT}/menu/${data.id}`)
    }

    const handleAdquisicion = async (id) => {
        const data = await guardarSesion(id, 'Adquisiciones')
        //console.log(`data ${JSON.stringify(data)}`)
        //return
       window.location.replace(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_FRONTEND_ADQUISICIONES_PORT}/${data.id}`)
    }
    const handleServicios = async (id) => {

        const data = await guardarSesion(id, 'Servicios')

        window.location.replace(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_FRONTEND_SERVICIOS_PORT}/${data.id}`)
    }
    useEffect(() => {
        (async () => {
            await obtenerReglasMonitores()
            await obtenerReglasEmergencias()
            await obtenerReglasAdquisiciones()
        })()
        // eslint-disable-next-line
    }, [])
    return (

        <Grid container direction='row' justifyContent='center' spacing={1} style={{ marginTop: 50 }}>

            {Number(sessionStorage.getItem('idEntidad')) !== 0 ?
                <Grid item md={12} lg={4}>
                    <Card style={{ height: '100%', width: '100%' }}>
                        <CardHeader title='Buzón UAM-L'></CardHeader>
                        <CardContent>
                            <Typography component='span' style={{ color: 'rgb(156, 39, 176)', fontSize: 'inherit' }}>Importante:</Typography><Typography component='span' style={{ color: 'black', fontSize: 'inherit' }}> Si tienes algún problema con la aplicación por favor envía una captura de pantalla y qué dispositivo estabas usando (por ejemplo celular motorola A20 o Tablet Amazon Fire HD) cuando se presentó el problema al correo </Typography><Typography component='span' style={{ color: 'rgb(156, 39, 176)', fontSize: 'inherit' }}>fmedina@correo.ler.uam.mx<br />&nbsp;</Typography>
                            <Grid container direction='row'>
                                <Grid xl={12} sm={12}>
                                    <Tooltip title="Click aquí para ir a la aplicación de Buzón UAM-L" arrow placement="left-end"><Button variant="outlined" color='secondary' sx={{ marginRight: 2 }} onClick={() => handleBuzon(id)}><img src='/images/buzon.png' alt='Click para ir a la aplicación de buzon' width={50}></img></Button></Tooltip>
                                    <Button variant="outlined" color='secondary' sx={{ marginRight: 2 }} onClick={() => handleBuzon(id)}>Mi aplicación <img src='/images/cursor.png' alt='' width={20}></img></Button>
                                </Grid>
                                <Grid xl={12} sm={12}>
                                    <List
                                        sx={{ width: '100%', bgcolor: 'background.paper' }}
                                        aria-label="contacts"
                                    >
                                        <ListItem disablePadding onClick={() => handleBuzon(id, 'ayuda')}>
                                            <Tooltip title="Click aquí para registrar solicitud de intervención psicológica breve" arrow placement="right-end">
                                                <ListItemButton>
                                                    <ListItemIcon>
                                                        <CheckCircleTwoToneIcon color='secondary' />
                                                    </ListItemIcon>
                                                    <ListItemText primary="Ayuda psicológica" />
                                                </ListItemButton>
                                            </Tooltip>
                                        </ListItem>
                                        <ListItem disablePadding onClick={() => handleBuzon(id, 'quejaVG')}>
                                            <Tooltip title="Click aquí para registrar queja o eventualidad por violencia de género" arrow placement="right-end">
                                                <ListItemButton>
                                                    <ListItemIcon>
                                                        <CheckCircleTwoToneIcon color='secondary' />
                                                    </ListItemIcon>
                                                    <ListItemText primary="Quejas y eventualidades por violencia de género" />
                                                </ListItemButton>
                                            </Tooltip>
                                        </ListItem>
                                        <hr />
                                        <ListItem disablePadding onClick={() => handleBuzon(id, 'comentario')}>
                                            <Tooltip title="Click aquí para registrar evaluación de un servicio" arrow placement="right-end">
                                                <ListItemButton>
                                                    <ListItemIcon>
                                                        <CheckCircleTwoToneIcon color='secondary' />
                                                    </ListItemIcon>
                                                    <ListItemText primary="Evaluación de servicios" />
                                                </ListItemButton>
                                            </Tooltip>
                                        </ListItem>
                                        <hr />
                                        <ListItem disablePadding onClick={() => handleBuzon(id, 'falta')}>
                                            <Tooltip title="Click aquí para registrar faltas por integrantes de la comunidad universitaria (Te atenderán las Secretarías Divisionales o Secretaría de Unidad, según corresponda)" arrow placement="right-end">
                                                <ListItemButton>
                                                    <ListItemIcon>
                                                        <CheckCircleTwoToneIcon color='secondary' />
                                                    </ListItemIcon>
                                                    <ListItemText primary="Registrar faltas por integrantes de la comunidad universitaria" />
                                                </ListItemButton>
                                            </Tooltip>
                                        </ListItem>
                                        <ListItem disablePadding onClick={() => handleBuzon(id, 'ayudaUrgente')}>
                                            <Tooltip title="Click aquí para registrar solicitud de ayuda urgente (Te atenderán las Secretarías Divisionales o Secretaría de Unidad, según corresponda)" arrow placement="right-end">
                                                <ListItemButton>
                                                    <ListItemIcon>
                                                        <CheckCircleTwoToneIcon color='secondary' />
                                                    </ListItemIcon>
                                                    <ListItemText primary="Registrar solicitud de ayuda urgente" />
                                                </ListItemButton>
                                            </Tooltip>
                                        </ListItem>

                                    </List>

                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>
                </Grid> : <Grid item md={12} lg={4}></Grid> 
            }
            <Grid item md={12} lg={8}>
                <Grid container direction='row'  justifyContent="flex-start" spacing={2}>
                    {isGestion ?
                        <Grid item md={12} lg={6}>
                            <Card style={{ height: '100%', width: '100%' }}>
                                <CardHeader title='Gestión presupuestal'></CardHeader>
                                <CardContent>
                                    <Grid container direction='row'>
                                        <Grid md={12} lg={3}>
                                            <Button variant="outlined" color='secondary' sx={{ marginRight: 2 }} onClick={() => handleGestion(id)}><PriceChangeTwoToneIcon sx={{ fontSize: '50px' }}></PriceChangeTwoToneIcon></Button>
                                        </Grid>
                                        {<Grid md={12} lg={8}>
                                            Gestión el ejercicio presupuestal de la unidad.
                                        </Grid>}
                                    </Grid>
                                </CardContent>
                            </Card>
                        </Grid>
                        : <></>
                    }
                    {isGestion || isAdminAdquisiciones ?
                        <Grid item md={12} lg={6}>
                            <Card style={{ height: '100%', width: '100%' }}>
                                <CardHeader title='Adquisiciones'></CardHeader>
                                <CardContent>
                                    <Grid container direction='row'>
                                        <Grid md={12} lg={3}>
                                            <Button variant="outlined" color='secondary' sx={{ marginRight: 2 }} onClick={() => handleAdquisicion(id)}><ShoppingCartTwoToneIcon sx={{ fontSize: '50px' }}></ShoppingCartTwoToneIcon></Button>
                                        </Grid>
                                        {<Grid md={12} lg={8}>
                                            Seguimiento de solicitudes de adquisición en CSA.
                                        </Grid>}
                                    </Grid>
                                </CardContent>
                            </Card>
                        </Grid>
                        : <></>
                    }
                    {isComite || isTitular || (isMonitor && Number(sessionStorage.getItem('idEntidad')) !== 0 ) ?
                        <Grid item md={12} lg={6}>
                            <Card style={{ height: '100%', width: '100%' }} >
                                <CardHeader title='Monitores UAM-L' style={{width:'100%'}}></CardHeader>
                                <CardContent>
                                    <Grid container direction='row' style={{width:'100%'}}>
                                        <Grid md={12} lg={3}>
                                            <Button variant="outlined" color='secondary' sx={{ marginRight: 2 }} onClick={() => handleMonitores(id)}><Diversity3TwoToneIcon sx={{ fontSize: '50px' }}></Diversity3TwoToneIcon></Button>
                                        </Grid>
                                        {<Grid md={12} lg={8}>
                                            Asignación económica temporal para el alumnado y las personas egresadas de los planes de estudio de la unidad que participan como monitoras y monitores universitarios, en programas y proyectos de interés institucional y alto impacto social.
                                        </Grid>}
                                    </Grid>
                                </CardContent>
                            </Card>
                        </Grid>
                        :
                        <></>
                    }
                    {isAdminEmergencias || isAlumnoEmergencias ?
                        <Grid item md={12} lg={6}>
                            <Card style={{ height: '100%', width: '100%' }}>
                                <CardHeader title='Actualización de datos personales'></CardHeader>
                                <CardContent>
                                    <Grid container direction='row'>
                                        <Grid md={12} lg={3}>
                                            <Button variant="outlined" color='secondary' sx={{ marginRight: 2 }} onClick={() => handleEmergencias(id)}><MedicalInformationTwoToneIcon sx={{ fontSize: '50px' }}></MedicalInformationTwoToneIcon></Button>
                                        </Grid>
                                        {<Grid md={12} lg={8}>
                                            {isAlumnoEmergencias ? 'Es muy importante mantener tu información actualizada' : 'Consulta de información del alumnado'}
                                        </Grid>}
                                    </Grid>
                                </CardContent>
                            </Card>
                        </Grid>
                        :
                        <></>
                    }
                    {/*<Grid item md={12} lg={6}>
                            <Card style={{ height: '100%', width: '100%' }}>
                                <CardHeader title='Servicios'></CardHeader>
                                <CardContent>
                                    <Grid container direction='row'>
                                        <Grid md={12} lg={3}>
                                            <Button variant="outlined" color='secondary' sx={{ marginRight: 2 }} onClick={() => handleServicios(id)}><SettingsSuggestTwoToneIcon sx={{ fontSize: '50px' }}></SettingsSuggestTwoToneIcon></Button>
                                        </Grid>
                                        {<Grid md={12} lg={8}>
                                            Aplicación para solicitar y dar seguimiento a servicios otorgados por las coordinaciones
                                        </Grid>}
                                    </Grid>
                                </CardContent>
                            </Card>
                        </Grid>*/}
                </Grid>
            </Grid>
        </Grid>

    )
}